import { useState, useRef, useEffect } from 'react';
import Popper from '@mui/material/Popper';
import ColorPicker from 'react-pick-color';
import "../../../../assets/styles/containers/_clTagsSummary.scss";
import { ClickAwayListener, Grow, MenuList } from "@mui/material";
import toast from 'react-hot-toast';
import axios from "axios";
import config_settings from "../../../config/config";

// === Initialize BASE_URL ===
let BASE_URL;
const origin = () => {
    let origin = window.location.origin.toLowerCase();
    if (origin.includes("https://")) origin = origin.replace("https://", "");
    else origin = origin.replace("http://", "");
    BASE_URL = config_settings[origin]?.SERVER_URL;
};
origin();

const CLRatingColorPicker = ({ row, onColorChange, GetCommentLibTagList, isHTCompany }) => {
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [selectedColor, setSelectedColor] = useState(row?.color || "#ffffff");
    const [initialColor, setInitialColor] = useState(row?.color || "#ffffff"); // ✅ store the original color on open

    // Open the color picker
    const handleToggle = () => {
        setInitialColor(selectedColor); // store current color on open
        setOpen((prev) => !prev);
    };

    // On click outside, close and possibly update
    const handleClose = () => {
        setOpen(false);
        if (selectedColor !== initialColor) {
            handleSummaryColorChange(row);
        }
    };

    const handleColorChange = (color) => {
        setSelectedColor(color.hex);
        if (onColorChange) {
            onColorChange(row.id, color.hex); // update local UI
        }
    };

    const handleSummaryColorChange = async (row) => {
        const companyID = sessionStorage.getItem("company-key");

        const payload = {
            name: row.name,
            color: selectedColor,
            definition: row.definition,
            include_in_summary: row.include_in_summary
        };

        try {
            const response = await axios.put(`${BASE_URL}/ratings/${row.id}`, payload, {
                headers: {
                    "company-key": companyID
                }
            });

            if (response?.data?.success) {
                toast.success(response.data.message || "Color updated.");
                if (typeof GetCommentLibTagList === "function") {
                    GetCommentLibTagList();
                }
            } else {
                toast.error("Color update failed.");
            }
        } catch (error) {
            console.error("Color update error:", error);
            toast.error("Failed to update color.");
        }
    };

    return (
        <div style={{ paddingTop: "3px", height: "32px" }}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    // border: "1px solid #E5E8E8",
                    // backgroundColor: "white",
                    borderRadius: "6px",
                    width: "168px",
                    height: "32px",
                    padding: "5px",
                    gap: "5px",
                }}
                onClick={handleToggle}
                ref={anchorRef}
            >
                <div
                    style={{
                        width: "18px",
                        height: "18px",
                        borderRadius: "2px",
                        backgroundColor: selectedColor,
                        border: "1px solid #E5E8E8",
                    }}
                ></div>
                <span className='hex-color-title-text'>{selectedColor}</span>
            </div>

            <Popper
                transition
                open={open}
                disablePortal
                placement="left-start"
                anchorEl={anchorRef.current}
                style={{ zIndex: 999 }}
            >
                {({ TransitionProps }) => (
                    <Grow {...TransitionProps} style={{ transformOrigin: 'center top' }}>
                        <div className="color-picker-popper" style={{ marginRight: "5px" }}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList>
                                    <ColorPicker
                                        className='color-picker-summary'
                                        hideAlpha
                                        color={selectedColor}
                                        onChange={handleColorChange}
                                    />
                                    <span className="popper-arrow" data-popper-arrow></span>
                                </MenuList>
                            </ClickAwayListener>
                        </div>
                    </Grow>
                )}
            </Popper>
        </div>
    );
};

export default CLRatingColorPicker;
